import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import PopUp from "./Component/PopUp";
import { Button, Grid } from "@mui/material";
import { useUploadImage } from "hook/services";
import { useNavigate, useParams } from "react-router-dom";
const { v4: uuidv4 } = require("uuid");
import eyeIcon from "../../../../../assets/themeIcons/eye-view.svg";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";

function Events({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const uploadImage = useUploadImage();
  const navigate = useNavigate();
  const [eventsData, setEventsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);

  const getEvents = async () => {
    const { response } = await AppService.events.Get({
      query: `account_id=${formData._id}`,
    });
    if (response) {
      setEventsData(response.data);
    }
  };

  const [applicantsPopup, setApplicantsPopup] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const [currentFormData, setCurrentFormData] = useState({
    event_name: "",
    event_date: "",
    event_description: "",
    event_start_time: "",
    event_end_time: "",
    event_location: "",
    image: null,
  });

  const closeApplicantsPopup = () => setApplicantsPopup(false);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedEvent(null);
    setCurrentFormData({
      event_name: "",
      event_date: "",
      event_description: "",
      event_start_time: "",
      event_end_time: "",
      event_location: "",
      image: null,
    });
  };

  const openCropModal = (file) => {
    setTempImageFile(file);
    setCurrentImage(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-event-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        // Update the form with the new image URL
        setCurrentFormData(prev => ({
          ...prev,
          image: image_response.data
        }));
        setTempImageFile(null);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target?.files[0];
    if (file) {
      openCropModal(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let image_url = selectedEvent?.image || currentFormData.image || "";

    const imageInput = e.target?.image?.files[0];
    if (imageInput && !image_url) {
      const image_response = await uploadImageToGhl(imageInput, agency);
      image_url = image_response?.data || "";
    }

    const payload = {
      event_name: currentFormData?.event_name,
      event_date: currentFormData?.event_date,
      event_description: currentFormData?.event_description,
      event_start_time: currentFormData?.event_start_time,
      event_end_time: currentFormData?.event_end_time,
      event_location: currentFormData?.event_location,
      image: image_url,
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    };

    let response;

    if (selectedEvent) {
      response = await AppService.events.Update({
        payload: { ...payload, _id: selectedEvent._id },
      });
    } else {
      response = await AppService.events.Create({ payload });
    }

    if (response) {
      handleRefresh();
      closePopup();
      setSelectedEvent(null);
      getEvents();
      toast.success(
        selectedEvent ? "Event updated successfully!" : "New event created successfully!"
      );
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const handleEdit = (event) => {
    setSelectedEvent(event);
    setCurrentFormData({
      event_name: event?.event_name,
      event_date: event?.event_date,
      event_description: event?.event_description,
      event_start_time: event?.event_start_time,
      event_end_time: event?.event_end_time,
      event_location: event?.event_location,
      image: event.image,
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    });
    openPopup();
  };

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      const { response } = await AppService.events.Delete({
        query: `_id=${event._id}`,
      });

      if (response) {
        handleRefresh();
        getEvents();
        toast.success("Delete Successfully");
      }
    } catch (error) {
      toast.error("Error deleting attachment");
      console.error("Error deleting event:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEvents();
  }, [formData]);

  useEffect(() => {
    if (selectedEvent) {
      setCurrentFormData({
        event_name: selectedEvent?.event_name,
        event_date: selectedEvent?.event_date,
        event_description: selectedEvent?.event_description,
        event_start_time: selectedEvent?.event_start_time,
        event_end_time: selectedEvent?.event_end_time,
        event_location: selectedEvent?.event_location,
        image: selectedEvent?.image,
      });
    }
  }, [selectedEvent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setSuccess("");
  };

  const formatTo12Hour = time24 => {
    if (!time24) return "";
    const [hour, minute] = time24.split(':')
    const date = new Date()
    date.setHours(+hour)
    date.setMinutes(+minute)
    return date.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  return (
    <div>
      <p className="text-left" style={{ color: "#33a933" }}>
        {success}
      </p>
      <SoftBox>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
            <button
              className="btn-new-design-black"
              type="button"
              onClick={openPopup}
              style={{ background: "black", color: "white" }}
              disabled={loading}
            >
              Add New Event
            </button>
          </Grid>

          <Grid item xs={12}>
            <div
              className="d-flex justify-content-between"
              style={{
                margin: "10px 0px",
                padding: "20px",
                borderRadius: "18px",
                background: "#F7F7F7",
              }}
            >
              <p style={{ flex: 1, fontWeight: 600 }}>Name</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Date</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Start Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>End Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Action</p>
            </div>

            {eventsData?.map((event, index) => (
              <div
                className="d-flex justify-content-between"
                style={{
                  margin: "20px 0",
                  padding: "15px 10px",
                  borderBottom: "1px solid",
                  borderColor: "#DDDDDD",
                }}
                key={index}
              >
                <p style={{ flex: 1 }}>{event?.event_name}</p>
                <p style={{ flex: 1 }}>{event?.event_date}</p>
                <p style={{ flex: 1 }}>{formatTo12Hour(event?.event_start_time)}</p>
                <p style={{ flex: 1 }}>{formatTo12Hour(event?.event_end_time)}</p>

                <div
                  style={{ flex: 1, display: "flex", justifyContent: "flex-start", gap: "20px" }}
                >
                  <img
                    onClick={() =>
                      navigate(`../event-detail/${event._id}`, {
                        state: { event, applicants: event?.interested_users || [] },
                      })
                    }
                    width={25}
                    src={eyeIcon}
                    style={{ cursor: "pointer" }}
                    alt="View"
                  />
                  <img
                    onClick={() => handleEdit(event)}
                    disabled={loading}
                    width={20}
                    src={editIcon}
                    style={{ cursor: "pointer" }}
                    alt="Edit"
                  />
                  <img
                    onClick={() => handleDelete(event)}
                    disabled={loading}
                    width={20}
                    src={deleteIcon}
                    style={{ cursor: "pointer" }}
                    alt="Delete"
                  />
                </div>
              </div>
            ))}
          </Grid>
        </Grid>
      </SoftBox>

      <PopUp
        open={popup}
        handleClose={closePopup}
        title={selectedEvent ? "Edit Event" : "New Event"}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Name</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Name"
                  name="event_name"
                  value={currentFormData?.event_name}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Date</label>
                <input
                  type="date"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Date"
                  name="event_date"
                  value={currentFormData?.event_date}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Location</label>
                <input
                  type="text"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Location"
                  name="event_location"
                  value={currentFormData?.event_location}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className=" text-black">Start Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Start Time"
                  name="event_start_time"
                  value={currentFormData?.event_start_time}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">End Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="End Time"
                  name="event_end_time"
                  value={currentFormData?.event_end_time}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Image</label>
                <input
                  className="form-control-agust"
                  name="image"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                {currentFormData.image && (
                  <div style={{ marginTop: "10px" }}>
                    <img
                      src={currentFormData.image}
                      alt="Event preview"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px"
                      }}
                    />
                  </div>
                )}
              </SoftBox>
            </div>
          </div>

          <div style={{ padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Event Description</label>
              <textarea
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Event Description"
                name="event_description"
                rows={8}
                value={currentFormData?.event_description}
                disabled={loading}
                required
              />
            </SoftBox>
          </div>

          <div style={{ margin: "10px 0px", textAlign: "right" }}>
            <SoftButton
              variant="contained"
              type="submit"
              color="dark"
              disabled={loading}
            >
              {

                selectedEvent ? "Update Event" : "Add Event"}
            </SoftButton>
          </div>
        </form>
      </PopUp>

      <PopUp
        open={applicantsPopup}
        handleClose={closeApplicantsPopup}
        title="Intrested Persons"
        style={{ with: "70%" }}
      >
        <div
          style={{ padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", with: "70%" }}
        >
          {applicants.length > 0 ? (
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {applicants.map((applicant, index) => (
                <li
                  key={index}
                  style={{
                    padding: "12px",
                    margin: "8px 0",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    Name: {applicant?.first_name} {applicant?.last_name}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    Business Name: {applicant?.business_name}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p
              style={{
                fontSize: "14px",
                color: "#999",
                textAlign: "center",
              }}
            >
              No one is interested in this event.
            </p>
          )}
        </div>
      </PopUp>

      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
      // aspectRatio={16 / 9} // Good aspect ratio for event images
      />
    </div>
  );
}

export default Events;